import * as React from 'react'
import { cn } from '../../lib/cn'

/**
 * LinkButton — inline text link styled for the DS. Pencil kQlTI.
 * Use for navigation; for actions use Button variant="link".
 */
export const LinkButton = React.forwardRef<
  HTMLAnchorElement,
  React.AnchorHTMLAttributes<HTMLAnchorElement>
>(({ className, ...props }, ref) => (
  <a
    ref={ref}
    className={cn(
      'text-ia-text-link underline-offset-4 hover:underline',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-sm',
      className,
    )}
    {...props}
  />
))
LinkButton.displayName = 'LinkButton'
